module.exports = __webpack_public_path__ + "img/knight.34dee098.png";